import { CustomCard } from "../../../../components";
import TitleLine from "../../../../components/TitleLine";
import { ICreateAndUpdateCategory } from "../../../../types/category.interface";

const TypeContainer = ({
  items,
  title,
  onEdit,
  onRemove,
}: {
  items: any[];
  title?: string;
  onEdit?: (category: ICreateAndUpdateCategory) => void;
  onRemove?: (category: ICreateAndUpdateCategory) => void;
}) => {
  if (items?.length == 0 || items?.length === undefined) return <></>;
  return (
    <div>
      <TitleLine title={title as string} />
      <ul className="category-container">
        {items?.map((category: any, index: number) => {
          return (
            <li key={`driver-${index}`}>
              <CustomCard
                fieldName={"categoryName"}
                item={category}
                editable
                removable
                onEdit={onEdit}
                onRemove={onRemove}
                image={category?.picture}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TypeContainer;
